import { createContext } from 'react'
import type { Me } from '../lib/api/client'

export type AuthValue = {
  user: Me | null
  /** True until the stored token has been checked, so the app does not flash the
   *  sign-in screen at someone who is already signed in. */
  loading: boolean
  signIn: (email: string, password: string) => Promise<void>
  acceptInvite: (token: string, fullName: string, password: string) => Promise<void>
  signOut: () => void
  /** Re-read the signed-in account from the server.
   *
   *  Needed because a change to your own roles happens through an ordinary API
   *  call, and nothing else tells this context that the answer to `has()` just
   *  changed - so the navigation would keep hiding a screen you can now reach. */
  refresh: () => Promise<void>
  has: (...roles: string[]) => boolean
}

export const AuthContext = createContext<AuthValue | null>(null)
